// 获取唯一值
export function getUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c: string) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

// 打开指定url
export function openUrl(url: string, params: any) {
  const nodes: any = [];
  Object.keys(params).forEach((key: string) => {
    const content = params[key];
    if (content === undefined || content === null || content === '') {
      return;
    }
    nodes.push(`${key}=${params[key]}`);
  });
  const split = url.indexOf('?') === -1 ? '?' : '&';
  window.open(url + split + nodes.join('&'));
}

// 拼接员工数据
export function getMembers(data: any, usermap: any = {}) {
  const list: any = [];
  const usermapAll: any = usermap;
  data.map((item: any) => {
    // 拼接人员
    const children: any = item.users.map((user: any) => {
      let disabled = true;
      if (!usermapAll[user.id]) {
        disabled = false;
        usermapAll[user.id] = 1;
      }
      return { value: user.id, label: user.name, disabled };
    });
    list.push({ value: item.id, label: item.name, children });
    if (!item.children || item.children.length === 0) {
      return;
    }
    children.unshift(...getMembers(item.children, usermapAll));
  });
  return list;
}

